const generateErrorMessage = (error) => {
  let errorMessage = null;
  if (error.response?.data?.message) {
    const { data } = error.response;
    errorMessage = `${data.name}: ${data.message}`;
  } else {
    errorMessage = `Error: ${error.message}`;
    if (/timeout of [0-9]+ms exceeded/.test(error.message)) {
      errorMessage = errorMessage.concat('. Please reload the page');
    }
  }
  return errorMessage;
};

export default generateErrorMessage;
